<script setup lang="ts">
import type { CtaData } from '~/utils/crystallize/pieces'
import { getCtaProps } from '~/utils/crystallize/cta'

const { data } = defineProps<{
  data: CtaData | undefined | null
  boxed?: boolean
  contactButtonHref?: string
}>()

const cta = computed(() => getCtaProps(data))
</script>

<template>
  <section v-if="data">
    <ContentGrid>
      <div
        class="full-width-content grid grid-cols-subgrid items-center py-10 md:py-20"
        :class="{
          'bg-white rounded-4xl mb-10 md:mb-20 px-5 sm:px-10 md:px-20 lg:px-32': boxed,
        }"
      >
        <div class="col-span-full md:col-span-3 lg:col-span-4 2xl:col-span-5 flex flex-col gap-m">
          <h2 v-if="data.title" class="title-l" v-text="data.title" />

          <CrystallizeRichText v-for="(block, i) in data.text" :key="i" class="text-lg" :block="block" />

          <Button v-if="contactButtonHref" color="moss" variant="primary" :href="contactButtonHref">
            Ta kontakt
          </Button>
          <Button v-else-if="cta.action" color="moss" variant="primary" :to="cta.action.link">
            {{ cta.action.label }}
          </Button>
        </div>

        <StaticIllustration
          v-if="cta.illustration"
          class="hidden md:block lg:col-span-3 lg:col-start-6 2xl:col-start-8"
          :name="cta.illustration"
        />

        <CrystallizeClippedImage
          v-else-if="cta.image"
          :image="cta.image"
          path="hexagon-left"
          class="hidden lg:block shrink-0 my-m col-span-4 2xl:col-span-5 ml-[5vw]"
          img-class="rounded-r-3xl object-cover object-center max-h-80 w-full"
        />
      </div>
    </ContentGrid>
  </section>
</template>
